export default "__VITE_PUBLIC_ASSET__e8fa1911__"